import React from "react";
import { Grid, Input } from "@sumprio/ui";
import { SearchNormalIcon } from "@sumprio/ui/icons";

export interface TableHeaderBarProps {
  left: React.ReactNode;
  searchPlaceholder: string;
  searchValue: string;
  onSearchChange: (_value: string) => void;
  right?: React.ReactNode;
  minSearchWidthPx?: number;
}

export default function TableHeaderBar({
  left,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  right,
  minSearchWidthPx = 200,
}: TableHeaderBarProps) {
  return (
    <Grid
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap="md"
      width="100%"
    >
      <Grid display="flex" alignItems="center" gap="sm">
        {left}
      </Grid>
      <Grid display="flex" alignItems="center" gap="md" flexShrink={0}>
        <Input
          placeholder={searchPlaceholder}
          leadingIcon={<SearchNormalIcon />}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          clearable={!!searchValue}
          style={{ minWidth: minSearchWidthPx }}
        />
        {right ?? null}
      </Grid>
    </Grid>
  );
}
